const startPage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        login: 'Личный кабинет',
    },
    productDescription: 'Автоматизация деятельности членов коллегиальных органов, принимающих решения.',
};

export default startPage;
